// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"95e877fb","977":"fd22bec8"}[chunkId] + ".chunk.js";
};